import { render } from "./LoginUI.vue?vue&type=template&id=aacbf732&scoped=true"
const script = {}

import "./LoginUI.vue?vue&type=style&index=0&id=aacbf732&scoped=true&lang=css"

import exportComponent from "/builds/coditas-projects/dialog360-whatsapp/frontend/whatsapp-exotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aacbf732"]])

export default __exports__